;(function ($, window, document, undefined) {
    'use strict';

    var SearchPage = function (element, options) {
        var that = this;
        this.opts = options;
        this.els = options.els;

        this.init();
    };

    SearchPage.prototype = {

        init : function () {
            this.addMissingIcons();
            this.reposition();

            $('div.AdvancedThreadSearchForm').hide();
            $('.search-filters').hide();

            if (location.href.indexOf('tab/user') <= 0) {
                this.filters();
                this.trimMessages();
                this.observe();
            } else {
                this.filters(true);
            }
        },

        pagination: function () {
            $('.lia-paging-page-previous .lia-paging-page-arrow').html('<span class="icon icon--light"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="15" height="20" viewBox="0 0 7.5 10"><path d="M4.061,5.051 L7.461,8.068 L5.417,10.002 L-0.004,5.051 L5.529,-0.001 L7.499,1.798 L4.061,5.051 Z" class="cls-1"/></svg></span');
            $('.lia-paging-page-next .lia-paging-page-arrow').html('<span class="icon icon--light"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="15" height="20" viewBox="0 0 7.5 10"><path d="M3.439,4.949 L0.039,1.932 L2.083,-0.002 L7.504,4.949 L1.971,10.001 L0.001,8.202 L3.439,4.949 Z" class="cls-1"/></svg></span>');
        },

        observe: function () {
            var timer = null;
            var that = this;

            $('.lia-component-search-encapsulation').observe('childlist subtree', '.lia-quilt-row.lia-quilt-row-standard.lia-message-search-container.lia-component-search-widget-message-search', function (record) {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    if (!$('.lia-link-navigation.advanced-search-link.lia-custom-event').hasClass('active')) {
                        $('div.AdvancedThreadSearchForm').hide();
                        $('.search-filters').hide();
                    }
                    that.trimMessages();
                    that.pagination();
                    that.addMissingIcons();
                    that.filters(true);
                    that.reposition();
                }, 200);
            });
        },

        addMissingIcons: function () {
            $('div.lia-menu-navigation-wrapper.lia-menu-action').find('.lia-js-click-menu').append('<span class="icon icon--dark"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="28.75" height="20.06" viewBox="0 0 14.375 10.03"><path d="M7.253,4.589 L11.586,0.047 L14.363,2.777 L7.253,10.016 L-0.002,2.628 L2.582,-0.004 L7.253,4.589 Z" class="cls-1"/></svg></span>')
        },

        trimMessages: function () {
            $('.search-result-message-blurb-root').each(function () {
                $(this).text($.trim($(this).text()));
            });
        },

        reposition: function () {
            // var $links       = $('.search-result-menu-bar .search-result-syndicate').detach();
            // var $options     = $('.search-result-menu-bar .search-action-menu').detach();
            var $advanced    = $('a.lia-link-navigation[id*="advancedSearch"]').detach();
            var $topLinks    = $('.search-menu-bar .search-result-syndicate');
            var $topOptions  = $('.search-result-sorting .search-action-menu');
            var $topAdvanced = $('.search-result-sorting .lia-link-navigation.advanced-search-link.lia-custom-event');

            var sortByText = $('.search-result-sort-by-label').text().replace(':', ' ');
            $('.lia-js-menu-opener.default-menu-option.lia-js-click-menu.lia-link-navigation').prepend('<span>' + sortByText + '</span>');

            $advanced.append('<span class="icon icon--dark"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="28.75" height="20.06" viewBox="0 0 14.375 10.03"><path d="M7.253,4.589 L11.586,0.047 L14.363,2.777 L7.253,10.016 L-0.002,2.628 L2.582,-0.004 L7.253,4.589 Z" class="cls-1"/></svg></span>');

            // if ($topAdvanced.size() && $advanced.size()) {
            //     $topAdvanced.replaceWith($advanced);
            // } else {
                $('.search-result-sorting').prepend($advanced);
            // }

            $('.advancedSearchPanel').find('a[id*="advancedSearchPanel"]').click(function () {
                $advanced.toggleClass('active');
                $('.search-filters').toggle();
            });

            $advanced.click(function (e) {
                $(this).toggleClass('active');
                $('.search-filters').toggle();
            });

            // $options.find('.lia-js-menu-opener').html('<span class="icon icon--dark"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="36" height="16" viewBox="0 0 36 16"><path d="M30.062,13.005 L23.999,7.104 L26.159,5.002 L30.062,8.669 L33.683,5.042 L36.004,7.223 L30.062,13.005 ZM13.822,10.758 L14.652,12.948 L13.109,14.574 L11.036,13.750 L10.095,14.145 L9.270,16.001 L7.053,16.001 L6.251,14.156 L5.359,13.772 L3.320,14.552 L1.760,12.948 L2.563,10.829 L2.340,10.324 L-0.000,9.248 L-0.000,6.997 L2.340,5.920 L2.585,5.371 L1.716,3.076 L3.276,1.483 L5.582,2.384 L6.128,2.176 L7.075,0.001 L9.281,0.001 L10.240,2.154 L10.763,2.384 L13.014,1.483 L14.607,3.087 L13.760,5.349 L14.061,6.096 L16.000,6.997 L16.000,9.270 L14.061,10.148 L13.822,10.758 ZM8.000,5.449 C6.569,5.449 5.410,6.591 5.410,8.001 C5.410,9.412 6.569,10.554 8.000,10.554 C9.431,10.554 10.591,9.412 10.591,8.001 C10.591,6.591 9.431,5.449 8.000,5.449 Z" class="cls-1"></path></svg></span>')

            // if ($topOptions.size()) {
            //     $topOptions.replaceWith($options);
            // } else {
            //     $('.search-result-sorting').append($options);
            // }

            // if ($topLinks.size()) {
            //     $topLinks.replaceWith($links);
            // } else {
            //     $('.search-menu-bar').append($links);
            // }

            $('.SearchItemLayout').each(function () {
                var $author  = $(this).find('.lia-message-author');
                var $message = $(this).find('.search-result-message-blurb-root');
                var $date    = $(this).find('.lia-summary-view-statistic-post-date');
                var $hold    = $('<div class="details"></div>');
                var $stats   = $(this).find('.search-result-message-statistics .lia-quilt-column-alley-right');

                if (!$(this).find('.lia-summary-view-statistic-views').size()) {
                    var $views = $('.lia-summary-view-statistic-views').eq(0).clone();
                    $views.find('.search-count-stats').text(0);
                    $stats.prepend($views);
                }

                if (!$(this).find('.lia-summary-view-statistic-replies').size()) {
                    var $replies = $('.lia-summary-view-statistic-replies').eq(0).clone();
                    $replies.find('.search-count-stats').text(0);
                    $stats.prepend($replies);
                }

                if (!$(this).find('.lia-summary-view-statistic-kudos').size()) {
                    var $kudos = $('.lia-summary-view-statistic-kudos').eq(0).clone();
                    $kudos.find('.MessageKudosCount').text(0);
                    $stats.prepend($kudos);
                }

                $hold.append($date);
                $hold.append($author);
                $message.after($hold);
            });
        },

        filters: function (buttonsAlreadyThere) {
            var that = this;
            var $filters = this.$filters = $('.thread-search-filters');

            // $('.thread-search-container').prepend($filters);

            $filters.find('.filter-toggle').after('<div class="check"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="35" height="28.32" viewBox="0 0 17.5 14.16"><path d="M17.515,2.524 L5.932,14.166 L5.914,14.148 L5.897,14.166 L0.001,8.241 L2.519,5.710 L5.914,9.122 L14.997,-0.007 L17.515,2.524 Z" class="cls-1"/></svg></span></div>')

            $filters.find('.check').click(function(e) {
                e.preventDefault();
                $(this).prev().click();
            });

            // if (!buttonsAlreadyThere) {
            //     var $button = $('<a href="#" class="button__filters">Filters<span class="icon icon--dark"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="28.75" height="20.06" viewBox="0 0 14.375 10.03"><path d="M7.253,4.589 L11.586,0.047 L14.363,2.777 L7.253,10.016 L-0.002,2.628 L2.582,-0.004 L7.253,4.589 Z" class="cls-1"/></svg></span></a>');
            //     var $sorting = $('.search-result-sorting').detach();
            //     $('.lia-tabs-standard').wrap('<div class="tabs-header"></div>').after($sorting.addClass('show'));
            //     $sorting.find('#advancedSearch').after($button);

            //     $button.click(function (e) {
            //         e.preventDefault();

            //         $(this).toggleClass('button__filters--active');
            //         that.$filters.toggleClass('active');
            //     });
            // } else {
            //     $('.button__filters').removeClass('button__filters--active');
            // }

            var $legends = $filters.find('.lia-form-fieldset-wrapper legend');

            $legends.append('<span class="icon icon--dark"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="28.75" height="20.06" viewBox="0 0 14.375 10.03"><path d="M7.253,4.589 L11.586,0.047 L14.363,2.777 L7.253,10.016 L-0.002,2.628 L2.582,-0.004 L7.253,4.589 Z" class="cls-1"/></svg></span>');

            $legends.click(function (e) {
                e.preventDefault();
                $(this).closest('.lia-form-fieldset-wrapper').siblings().find('legend').removeClass('active');
                $(this).toggleClass('active');
            });
        }

    };

    $.fn.SearchPage = function (options){

        var args     = Array.prototype.slice.call(arguments, 1),
            $item    = $(this),
            instance = $item.data('SearchPage');

        if (!instance) {
            instance = new SearchPage(this, options);
            $item.data('SearchPage', instance);
        }

        if (typeof options === 'string') {
            instance[options].apply(instance, args);
        }

        return this;
    };

})(jQuery, window, document);
